<template>
  <div>
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">群组名称</span>
        <el-input
          v-model="group_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">群组编号</span>
        <el-input
          v-model="group_code"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableList"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      :cell-class-name="getCellClassName"
      default-expand-all
      @select="handleSelectionChange"
      @select-all="selectAll"
    >
      <el-table-column
        type="selection"
        class="groop_selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="group_name"
        label="群组名称"
      >
        <template slot-scope="scope">
          <div class="title">
            <span>{{ scope.row.group_name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="group_code"
        width="200px"
        label="群组编码"
      />
      <el-table-column
        prop="desc"
        label="描述"
      />
    </el-table>
    <div class="tr" />
    <div class="group-footer">
      <div>
        <el-button
          type="primary"
          @click="saveStoreAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedGroupsIds: {
      type: Array,
      default: () => {
        return []
      }
    },
    showGroup: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      tableList: [],
      sourceTableList: [],
      total_count: 0,
      // params: {
      //   group_code: '',
      //   group_name: ''
      // },
      group_name: '',
      group_code: '',
      searchPathMap: {}
    }
  },
  mounted () {
    if (this.showGroup) {
      this.getNewsList()
    }
    console.log('selectedGroupsIds', this.selectedGroupsIds)
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.group_code
    },

    // 查询门店
    searchList () {
      // this.getNewsList()
      const { tableList, group_name, group_code } = this
      // const {group_name,group_code} = params
      // 每次 查询前 恢复数据
      this.tableList = JSON.parse(JSON.stringify(this.sourceTableList))
      if (!group_name && !group_code) {
        return this.showSelectedGroupsIds()
      }
      tableList.forEach((d) => {
        this.searchTree(d)
      })
      this.tableList.forEach((d, idx) => {
        this.getSearchData(d, idx, this.tableList)
      })
      // 需要对searchPathMap 进行一次 去重
      // this.reSearch(this.searchPathMap)
      this.searchPathMap = {}
      this.showSelectedGroupsIds()
    },
    getSearchData (node, index, list) {
      const paths = Object.values(this.searchPathMap)
      let status = true
      if (!node) return
      for (let p in paths) {
        if (paths[p].indexOf(node.parent_path) != -1) {
          status = false
          break
        }
      }
      if (status) {
        list.splice(index, 1)
        return this.getSearchData(list[index], index, list)
      } else {
        node.children &&
          node.children.forEach((d, idx) => {
            this.getSearchData(d, idx, node.children)
          })
      }
    },
    reSearch (target) {
      let keys = Object.keys(target)
      let vals = Object.values(target)
      for (let i = 0; i < keys.length; i++) {
        for (let j = i + 1; j < vals.length; j++) {
          if (vals[j].indexOf(keys[i]) > -1) {
            delete target[keys[i]]
            return this.reSearch(target)
          }
        }
      }
      return target
    },

    searchTree (node) {
      const { group_name, group_code } = this
      const nameStatus = group_name && node.group_name.indexOf(group_name) > -1
      const codeStatus = group_code && node.group_code.indexOf(group_code) > -1
      if (nameStatus || codeStatus) {
        this.searchPathMap[node.id] = node.parent_path
      }
      if (node.children) {
        node.children.forEach((d) => {
          this.searchTree(d)
        })
      }
    },
    // table表格选择
    handleSelectionChange (val, row) {
      if (row.isSet) return this.handleSelectDomInput(row, true)
      if (row.children && row.children.length > 0) {
        let status = val.findIndex((v) => v.id === row.id) !== -1
        this.setCheck(row, status)
      }
    },
    // 禁用
    handleSelectDomInput (row, selected) {
      this.$refs.multipleTable.toggleRowSelection(row, false)
      const domInput = document
        .querySelector(`.row-${row.id}`)
        .querySelector('label')
        .querySelector('.el-checkbox__input')
      domInput.classList.add('is-disabled')
    },
    // 处理父级选中，子级全部禁用并清除勾选
    setCheck (row, selected) {
      row.children.forEach((v) => {
        this.$refs.multipleTable.toggleRowSelection(v, false)
        setTimeout(() => {
          const domInput = document
            .querySelector(`.row-${v.id}`)
            .querySelector('label')
            .querySelector('.el-checkbox__input')
          if (selected) {
            domInput.classList.add('is-disabled')
          } else {
            domInput.classList.remove('is-disabled')
          }
          v.isSet = selected
          if (v.children) {
            this.setCheck(v, selected)
          }
        }, 100)
      })
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('showDialogChange', false)
    },
    // 保存绑定
    saveStoreAction () {
      let selection = this.$refs.multipleTable.selection
        .filter((v) => {
          if (!v.isSet) return v.id
        })
        .map((d) => {
          return { id: d.id, group_code: d.group_code }
        })
      console.log('chooseGroups', selection)
      this.$emit('chooseGroups', selection)
    },
    // 获取门店列表
    async getNewsList () {
      this.loading = true
      const data = await this.$api.organization.getGroupsList(this.params)
      if (data) {
        this.loading = false
        this.tableList = data.list
        this.sourceTableList = JSON.parse(JSON.stringify(data.list))
        this.total_count = data.total_count
        this.showSelectedGroupsIds()
      }
    },
    showSelectedGroupsIds () {
      if (this.selectedGroupsIds) {
        this.selectedGroupsIds.forEach((v) => {
          this.selectItemOnGetList(v.id)
        })
      }
    },
    // 设置row的类名用于获取真实dom
    getCellClassName ({ row }) {
      return `row-${row.id}`
    },
    selectItemOnGetList (id) {
      this.$nextTick(() => {
        try {
          if (!id) {
            return
          }
          const dom = document.querySelector(`.row-${id}`).querySelector('label')
          console.log('dom', dom.className, typeof dom.className)
          if (dom.className.indexOf('is-checked') > -1) return
          dom.click()
        } catch (e) {
          console.log(e)
        }
      })
    },
    // 全选事件
    selectAll (val) {
      // this.$refs.multipleTable.clearSelection()
      console.log('全选事件selectAll', val)

      setTimeout(() => {
        if (val.length > 0) {
          val.map((v) => {
            this.handleSelectionChange(val, v)
          })
        } else {
          this.tableList.map((v) => {
            this.setCheck(v, false)
          })
        }
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.group-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}

::v-deep {
  // .el-table__header {
  //   .el-table-column--selection {
  //     .cell {
  //       .el-checkbox {
  //         display: none;
  //       }
  //     }
  //   }
  // }
  .el-table__cell {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
.title {
  display: inline-block;
  min-width: 120px;
  max-width: 220px;
  // line-height: 23px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
